var _circle, _path, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHoufyIconCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 80.6 74.4"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: "50%",
  cy: "50%",
  r: "48%",
  fill: "#fff"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#bb2a5a",
  stroke: "null",
  d: "M40.073 9.436 8.818 30.814l11.914 34.604h38.681l11.914-34.604zm15.586 18.071c0 1.77-1.142 6.614-2.285 9.997-.734 1.923-1.142 2.307-3.917 3.691l-3.1 1.461h2.203c1.142.077 2.121.154 2.121.462 0 1.23-1.958 2.537-5.712 3.768l-4.243 1.307 2.774.23 2.775.231-2.856 1.308c-2.204 1.076-4.08 1.46-8.08 1.845-5.059.462-5.385.539-7.017 2.076-1.959 1.846-3.346 2.154-3.917.923-.164-.538 2.121-3.076 8.16-8.766 4.652-4.383 8.405-8.228 8.405-8.536 0-1.538-2.203-.154-7.344 4.614l-5.468 5.152.245-3.23c.408-4.383 1.959-7.535 5.141-10.304 4.08-3.614 11.751-6.613 19.26-7.536l2.855-.307z"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: -118.336,
  cy: 79.245,
  r: 36.364,
  fill: "#fff",
  stroke: "#000"
})));
export { SvgHoufyIconCircle as ReactComponent };
export default __webpack_public_path__ + "183bde68dbcff95c8fade8707acb51ba.svg";